<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="page"
    :page-size="pageSize"
    :total="total"
    :background="true"
    layout="total, prev, pager, next, jumper"
    class="s-pagination"
  />
</template>

<script>

export default ({
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handleSizeChange (size) {
    },
    handleCurrentChange (page) {
      this.$emit('loadTablelist', page)
    }
  }
})
</script>

<style lang="scss" scoped>
.s-pagination {
  text-align: right;
  ::v-deep .el-pager li {
    min-width: 27px;
    width: 27px;
    height: 27px;
    line-height: 27px;
    font-weight: normal;
    background: #fff;
    border: 1px solid #EAEAEA;
  }
  ::v-deep .btn-prev, ::v-deep .btn-next {
    height: 27px;
    border: 1px solid #EAEAEA;
    background: #fff;
    &:hover {
      color: #409EFF;
    }
  }
}
</style>
